import { useCallback, useEffect, useState } from "react";

import { isDefined } from "./functions";

export const useElementWidth = <T extends HTMLElement = HTMLDivElement>(): [
  (node: T | null) => void,
  number | undefined,
] => {
  const [elementWidth, setElementWidth] = useState<number | undefined>();
  const [element, setElement] = useState<T | null>(null);
  const additionsRefCallback = useCallback((node: T) => setElement(node), []);

  useEffect(() => {
    if (!isDefined(element)) {
      setElementWidth(undefined);
      return;
    }

    const elementResizeObserver = new ResizeObserver((entries) =>
      entries.forEach((entry) => {
        setElementWidth(entry.contentRect.width);
      }),
    );
    elementResizeObserver.observe(element);
    return () => elementResizeObserver.disconnect();
  }, [element]);

  return [additionsRefCallback, elementWidth];
};
